import { AppBar, Box, Button, Link, Stack, styled } from "@mui/material";

const StyledLink = styled(Link)(({ theme }) => ({
  color: "black",
  textDecoration: "none",
  fontSize: 16,
}));

export default function Navigation() {
  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        px: 3,
        py: 1.5,
        bgcolor: "#F5F9FF",
      }}
    >
      <Box sx={{ width: 5, height: 5 }}>
        {/* <img src={require("../../Assets/Images/headerIcon.png")} alt="icon" /> */}
      </Box>

      <Stack direction="row" spacing={5}>
        <StyledLink>Team</StyledLink>
        <StyledLink>Ontwerpopgave</StyledLink>
        <StyledLink>Onderzoek</StyledLink>
        <StyledLink>Richtlijnen</StyledLink>
        <StyledLink>Concepten</StyledLink>
        <StyledLink>Vervolg</StyledLink>
      </Stack>

      <Button
        variant="outlined"
        sx={{ color: "#E94F37", borderRadius: "20px", borderColor: "#E94F37", height: "30px" }}
      >
        Contact
      </Button>
    </AppBar>
  );
}
